module.exports = __webpack_public_path__ + "images/wifi30065762ede807f6b6894d76b85771db.png";